import { useDisclosure } from "@ui/hooks/useDisclosure";
import { Box } from "@ui/components/layout/box/Box";
import {
    SelectDropdown,
    SelectDropdownButton,
    SelectDropdownItem,
    SelectDropdownList,
} from "@ui/components/overlay/select-dropdown/SelectDropdown";
import React, { useContext, useRef } from "react";
import { Controller } from "./controller";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ClickAndCollect, CommonCMS } from "@lib/constants/contentful";

export const FilterDropdowns = ({ values, filterType }) => {
    const menuButtonRef = useRef();
    const { getMultiple } = useMicrocopy();
    const microcopies = (() => {
        return getMultiple(CommonCMS.page, [
            ClickAndCollect.SortBy,
            ClickAndCollect.FilterBy,
            ClickAndCollect.distance,
            ClickAndCollect.eccoStores,
        ]);
    })();

    const { filterDistance, storeTypeFilter, setFilterDistance, setStoreTypeFilter } =
        useContext(Controller);
    const { onOpen, onClose } = useDisclosure();

    const filterDistanceData = {
        placeholder: microcopies[ClickAndCollect.FilterBy],
        setFilter: setFilterDistance,
        value: filterDistance?.label,
    };

    // We create the object outside the microcopy context and will be translatable
    const labelToMicrocopy = (label) => {
        return label === "ECCO Stores"
            ? microcopies[ClickAndCollect.eccoStores]
            : microcopies[ClickAndCollect.distance];
    };

    const storeTypeFilterData = {
        placeholder: `${microcopies[ClickAndCollect.SortBy]} ${labelToMicrocopy(storeTypeFilter.label)}`,
        setFilter: setStoreTypeFilter,
        value: labelToMicrocopy(storeTypeFilter?.label),
    };

    const isDistanceFilter = filterType === "distance";

    return (
        <Box w={["100%", "auto"]}>
            <SelectDropdown
                matchWidth={true}
                variant="filled"
                onOpen={onOpen}
                onClose={onClose}
                closeOnSelect={true}
                boundary={"scrollParent"}
                flip={false}
                gutter={1}
            >
                {({ isOpen }) => (
                    <>
                        <SelectDropdownButton
                            zIndex={1}
                            ref={menuButtonRef}
                            sx={{
                                fontWeight: "bold",
                                gap: [2, 3],
                                height: 10,
                                width: ["100%", "fit-content"],
                                border: "none",
                                px: [3, 4],
                                "& span": {
                                    ml: 0,
                                    "& svg": {
                                        ml: 0,
                                    },
                                },
                            }}
                        >
                            {isDistanceFilter
                                ? filterDistanceData.value
                                    ? `${microcopies[ClickAndCollect.distance]}: ${filterDistanceData.value}`
                                    : filterDistanceData.placeholder
                                : storeTypeFilterData.placeholder}
                        </SelectDropdownButton>
                        {isOpen && (
                            <SelectDropdownList zIndex={[4, 2]}>
                                {values.map((value) => (
                                    <SelectDropdownItem
                                        py="2"
                                        px="4"
                                        fontWeight="bold"
                                        key={value.value}
                                        onClick={() => {
                                            onClose();
                                            isDistanceFilter
                                                ? filterDistanceData.setFilter(value)
                                                : storeTypeFilterData.setFilter(value);
                                        }}
                                    >
                                        {isDistanceFilter
                                            ? value.label
                                            : labelToMicrocopy(value.label)}
                                    </SelectDropdownItem>
                                ))}
                            </SelectDropdownList>
                        )}
                    </>
                )}
            </SelectDropdown>
        </Box>
    );
};
